var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@synisys/idm-authentication-client-js';
import { DePermissionService, DeSerializationService, DeService, } from '@synisys/idm-de-service-client-js';
import { FormService } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService, MetaCategoryId } from '@synisys/idm-kb-service-client-js';
import { LockingService } from '@synisys/idm-lock-service-client-js';
import { ValidationService } from '@synisys/idm-validation-calculation-service-client-js';
import { cloneDeep, isNil } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { of } from 'rxjs/observable/of';
import { zip } from 'rxjs/observable/zip';
import { catchError, filter, first, map, mapTo, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { noop } from 'rxjs/util/noop';
import { DynamicLayoutType } from '../../component/dynamic-layout';
import { PopupSubFormComponent } from '../../component/popup/popup-sub-form.component';
import { ActionNotificationData, ActionNotifierKey } from '../../concepts';
import { ActionBuilder, ContextArg, ContextArgEnum } from '../layout-actions';
import { defaultValueProvider } from '../utils';
import { DynamicFormDocumentsService } from './dynamic-form-documents.service';
import { MetaFormHelperService } from './meta-form-helper.service';
import { AbstractDestructionSubject } from '../../component';
var DynamicFormWorkflowService = /** @class */ (function (_super) {
    __extends(DynamicFormWorkflowService, _super);
    function DynamicFormWorkflowService(authenticationService, validationService, deSerializationService, deService, kbService, formService, dynamicFormDocumentsService, dePermissionService, lockService, metaFormHelperService, router) {
        var _this = _super.call(this) || this;
        _this.authenticationService = authenticationService;
        _this.validationService = validationService;
        _this.deSerializationService = deSerializationService;
        _this.deService = deService;
        _this.kbService = kbService;
        _this.formService = formService;
        _this.dynamicFormDocumentsService = dynamicFormDocumentsService;
        _this.dePermissionService = dePermissionService;
        _this.lockService = lockService;
        _this.metaFormHelperService = metaFormHelperService;
        _this.router = router;
        return _this;
    }
    DynamicFormWorkflowService_1 = DynamicFormWorkflowService;
    DynamicFormWorkflowService.openPopup = function (form, categoryName, formKey, formId, actionId, formData) {
        var popupProperties = formData.model.content.properties.generalProperties.get('workflow_popup_properties');
        var width = popupProperties['width'];
        var height = popupProperties['height'];
        var title = popupProperties['titleString'];
        var dialogRef = form.dialog.open(PopupSubFormComponent, {
            disableClose: true,
            //height,
            width: width,
            data: {
                form: form,
                formId: formId,
                categoryName: categoryName,
                title: title,
                entity: form.entity,
                formKey: formKey,
                layoutType: DynamicLayoutType.workflowForm,
                actionId: actionId,
            },
        });
        form.activePopup = dialogRef.componentInstance;
        return dialogRef.afterClosed();
    };
    DynamicFormWorkflowService.emitWorkflowEvent = function (form, serviceResponse, actionKey) {
        form.actionNotifier.next(new ActionNotificationData(actionKey, serviceResponse));
    };
    DynamicFormWorkflowService.prototype.doWorkflowAction = function (actionId, form) {
        var _this = this;
        if (isNil(actionId) || actionId === 0) {
            throw Error('actionId not given');
        }
        var result = new Subject();
        this.emptyActionDataAndCloneOther(form.entity, form.metaForm.layoutModel.category)
            .pipe(first(), switchMap(function () { return _this.workflowAction(actionId, form); }))
            .subscribe(function (res) {
            result.next(res);
            result.complete();
        }, console.error);
        return result;
    };
    DynamicFormWorkflowService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('onDoWorkflowAction')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            ContextArg(ContextArgEnum.ACTION_NOTIFIER),
            ContextArg(ContextArgEnum.FORM),
        ])
            .action(function (event, actionNotifier, form) { return _this.doWorkflowAction(event, form); })
            .build());
        result.push(new ActionBuilder()
            .name('doWorkflowWithoutCleaning')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            ContextArg(ContextArgEnum.FORM),
        ])
            .action(function (event, form) {
            return _this.workflowAction(event, form);
        })
            .build());
        result.push(new ActionBuilder()
            .name('openWorkflowPopup')
            .action(function (rootForm, categoryName, formKey, formId, actionId) {
            return _this.openWorkflowPopup(rootForm, categoryName, formKey, formId, actionId);
        })
            .build());
        return result;
    };
    DynamicFormWorkflowService.prototype.workflowAction = function (actionId, form) {
        var _this = this;
        zip(this.lockService.getLock(form.metaForm.layoutModel.category, form.entity.getInstanceId()), this.lockService.getPermanentLock(form.metaForm.layoutModel.category, form.entity.getInstanceId()))
            .pipe(switchMap(function (locksData) {
            var lockedLockData = locksData.find(function (lockData) { return lockData.getIsLocked(); });
            if (lockedLockData) {
                return _this.authenticationService.getUserData().pipe(switchMap(function (userData) {
                    if (lockedLockData.userId !== userData.userId) {
                        form.publishEvent('workflow_action_failed_locked_by_user', 'Error', 'de_save_error_mode', [lockedLockData.userFullName]);
                        return Observable.empty();
                    }
                    return _this.deService.doWorkflowAction(form.metaForm.layoutModel.category, form.entity, actionId);
                }));
            }
            return _this.deService.doWorkflowAction(form.metaForm.layoutModel.category, form.entity, actionId);
        }), catchError(function (error) {
            if (error.status === 409) {
                form.publishEvent('de_entity_already_updated', 'Error', 'de_save_error_mode');
                form.formLoadingShow = false;
                form.formLoadingFail = true;
                return Observable.throw('Entity is already updated');
            }
            return Observable.throw(error);
        }), switchMap(function (serviceResponse) {
            var validations = serviceResponse
                .getMeta()
                .getValidations();
            form.setMainEntityValidations(validations);
            if (validations.length > 0) {
                form.publishEvent('workflow_validation_errors', 'Error', 'de_save_error_mode');
                form.formLoadingShow = false;
                form.formLoadingFail = true;
                DynamicFormWorkflowService_1.emitWorkflowEvent(form, serviceResponse, ActionNotifierKey.DO_WORKFLOW_ACTION);
                return of(serviceResponse);
            }
            _this.dynamicFormDocumentsService
                .confirmDocumentsUploadAndReset(form.entity, form)
                .subscribe(noop, console.error);
            // Only if false, not falsy
            // tslint:disable-next-line:no-boolean-literal-compare
            if (serviceResponse.hasViewPermission === false) {
                _this.router.navigateByUrl('dynamic-de/no-permission/view');
            }
            else {
                form.entity = serviceResponse.getData();
                form.oldEntity = form.entity.clone();
                form.initWorkflowActions();
            }
            if (form.activePopup) {
                form.activePopup.dialogRef.close(true);
            }
            DynamicFormWorkflowService_1.emitWorkflowEvent(form, serviceResponse, ActionNotifierKey.DO_WORKFLOW_ACTION);
            return _this.updatePermissionsAfterWorkflowAction(form).pipe(mapTo(serviceResponse), tap(function () { return form.resetForm(); }));
        }), switchMap(function (serviceResponse) {
            return _this.metaFormHelperService
                .updateRequiredFields(form.metaForm, form.entity)
                .pipe(map(function () { return serviceResponse; }));
        }), tap(function (serviceResponse) {
            return DynamicFormWorkflowService_1.emitWorkflowEvent(form, serviceResponse, ActionNotifierKey.POST_WORKFLOW_ACTION);
        }, function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
            }
        }))
            .first()
            .subscribe(noop, console.error);
        return form.actionNotifier.pipe(filter(function (data) { return data.key === ActionNotifierKey.DO_WORKFLOW_ACTION; }), map(function (notificationData) { return notificationData.data; }));
    };
    DynamicFormWorkflowService.prototype.emptyActionDataAndCloneOther = function (entity, categoryName) {
        return zip(this.kbService.getMetaFields(categoryName), this.kbService.getMetaCategoryByMetaCategoryId(new MetaCategoryId(categoryName))).pipe(map(function (_a) {
            var metaFields = _a[0], metaCategory = _a[1];
            // tslint:disable-next-line:no-any
            var oldValues = new Map();
            var actionFieldsNames = metaCategory
                .getActionDataMetaFieldIds()
                .map(function (actionDataField) { return actionDataField.getSystemName(); });
            metaFields.map(function (metaField) {
                var systemName = metaField.getSystemName();
                oldValues.set(systemName, cloneDeep(entity.getProperty(systemName).value));
                if (actionFieldsNames.indexOf(systemName) !== -1) {
                    // empty action fields
                    entity.getProperty(systemName).value = defaultValueProvider(metaField.getType());
                }
            });
            return oldValues;
        }));
    };
    DynamicFormWorkflowService.prototype.resetData = function (entity, oldValues) {
        oldValues.forEach(function (value, key) { return (entity.getProperty(key).value = value); });
    };
    DynamicFormWorkflowService.prototype.updatePermissionsAfterWorkflowAction = function (form) {
        if (!form.entity || !form.entity.getInstanceId()) {
            return of(undefined);
        }
        else {
            return this.metaFormHelperService
                .updateDePermissions(form.metaForm, form.entity)
                .pipe(mapTo(undefined));
        }
    };
    DynamicFormWorkflowService.prototype.openWorkflowPopup = function (form, categoryName, formKey, formId, actionId) {
        var _this = this;
        form.popupEditMode = true;
        combineLatest(this.formService.loadForm(formKey, formId, categoryName), this.emptyActionDataAndCloneOther(form.entity, categoryName))
            .pipe(switchMap(function (_a) {
            var formData = _a[0], oldValues = _a[1];
            return DynamicFormWorkflowService_1.openPopup(form, categoryName, formKey, formId, actionId, formData).pipe(tap(function (workflowPopupResult) {
                if (!workflowPopupResult) {
                    form.actionNotifier.next(new ActionNotificationData(ActionNotifierKey.CANCEL_ACTION, undefined));
                    _this.resetData(form.entity, oldValues);
                }
            }));
        }), takeUntil(this.destroySubject$))
            .subscribe(noop, console.error);
        return form.actionNotifier.pipe(filter(function (data) {
            return data.key === ActionNotifierKey.DO_WORKFLOW_ACTION ||
                data.key === ActionNotifierKey.CANCEL_ACTION;
        }), map(function (notificationData) { return notificationData.data; }));
    };
    DynamicFormWorkflowService = DynamicFormWorkflowService_1 = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [AuthenticationService,
            ValidationService,
            DeSerializationService,
            DeService,
            KbService,
            FormService,
            DynamicFormDocumentsService,
            DePermissionService,
            LockingService,
            MetaFormHelperService,
            Router])
    ], DynamicFormWorkflowService);
    return DynamicFormWorkflowService;
    var DynamicFormWorkflowService_1;
}(AbstractDestructionSubject));
export { DynamicFormWorkflowService };
//# sourceMappingURL=dynamic-form-workflow.service.js.map